import * as React from 'react'
import './spinner.css'
import Spinner from './Spinner'
import { Component } from 'react'
import { Props } from './typings'
import { stateDecorator } from './stateDecorator'

class Modal extends Component<Props> {
  render() {
    const { loadingState } = this.props
    const display = loadingState == 'visible' ? 'flex' : 'none'
    return (
      <div id="modal-root" style={{ display }}>
        <Spinner></Spinner>
      </div>
    )
  }
}

export default stateDecorator(Modal)
